module.exports={
	"Scope": "Project-List",
	"CoreEntity": "Project",
	"TitleTemplate": "Projects",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Name",
			"Hash": "ProjectListName",
			"PictDashboard": {}
		},
		"Status":
		{
			"Name": "Status",
			"Hash": "ProjectListStatus",
			"PictDashboard":
			{
				"ValueTemplate": "<span class=\"tag has-text-weight-bold {~TIfAbs:PSRS-StatusTag-Success:Record:Record.Payload.Status^==^Active~}{~TIfAbs:PSRS-StatusTag-Info:Record:Record.Payload.Status^==^Pending~}{~TIfAbs:PSRS-StatusTag-Danger:Record:Record.Payload.Status^==^Closed~}\">{~D:Record.Payload.Status~}</span>"
			}
		}
	}
}
